import { TenantExpanded } from '@engine/models'

import { KeyValueDisplay, KeyValueItem } from '#components/KeyValueDisplay'

interface TenantDetailsProps {
  tenant: TenantExpanded
}

const TenantDetails = ({ tenant }: TenantDetailsProps) => {
  const items: KeyValueItem[] = [
    {
      label: 'Tenant ID',
      value: <span className="font-mono text-sm">{tenant._id}</span>,
    },
    {
      label: 'Type',
      value: tenant.isThirdPartyLogistics ? '3PL' : 'Direct Shipper',
    },
    {
      label: 'Created',
      value: new Date(tenant.createdAt).toLocaleString(),
    },
  ]

  if (tenant.isThirdPartyLogistics && tenant.thirdPartyLogisticsName) {
    items.push({
      label: '3PL Name',
      value: tenant.thirdPartyLogisticsName,
    })
  }

  if (tenant.notes) {
    items.push({
      label: 'Notes',
      value: tenant.notes,
      span: 2,
    })
  }

  if (tenant.webhooks?.tender && tenant.webhooks.tender.length > 0) {
    items.push({
      label: 'Tender Webhooks',
      value: (
        <div className="space-y-2">
          {tenant.webhooks.tender.map((webhook, idx) => (
            <div
              key={idx}
              className="rounded border border-base-300 bg-base-200 p-2"
            >
              <p className="text-xs font-semibold opacity-70">
                v{webhook.version}
              </p>
              <p className="break-all text-xs font-mono text-info">
                {webhook.url}
              </p>
            </div>
          ))}
        </div>
      ),
      span: 2,
    })
  }

  if (tenant.webhooks?.tracking && tenant.webhooks.tracking.length > 0) {
    items.push({
      label: 'Tracking Webhooks',
      value: (
        <div className="space-y-2">
          {tenant.webhooks.tracking.map((webhook, idx) => (
            <div
              key={idx}
              className="rounded border border-base-300 bg-base-200 p-2"
            >
              <p className="text-xs font-semibold opacity-70">
                v{webhook.version}
              </p>
              <p className="break-all text-xs font-mono text-info">
                {webhook.url}
              </p>
            </div>
          ))}
        </div>
      ),
      span: 2,
    })
  }

  items.push({
    label: 'Auth Token',
    value: <span className="font-mono text-warning">{tenant.authToken}</span>,
    span: 2,
  })

  return <KeyValueDisplay items={items} />
}

export { TenantDetails }
